'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { isRtlLocale } from '@/shared/constants/locales';

/**
 * Hook to sync dir attribute with current locale for RTL support
 * Automatically updates HTML dir attribute when locale changes
 */
export function useRtlSync() {
  const locale = useLocale();

  useEffect(() => {
    const htmlElement = document.documentElement;
    const dir = isRtlLocale(locale) ? 'rtl' : 'ltr';

    // Only update if changed to avoid unnecessary DOM updates
    if (htmlElement.getAttribute('dir') !== dir) {
      htmlElement.setAttribute('dir', dir);
    }
  }, [locale]);
}
